const uploadHandlers = new Map()

export const registerUploadHandler = (type, handler) => {
  uploadHandlers.set(type, handler)
}

export const getUploadHandler = (type, upload) => {
  if (type && uploadHandlers.has(type)) return uploadHandlers.get(type)
  return [...uploadHandlers.values()].find((handler) => handler.canHandle?.(upload))
}
